import { render, staticRenderFns } from "./CategoryStoreForm.vue?vue&type=template&id=090fb89a"
import script from "./CategoryStoreForm.vue?vue&type=script&lang=js"
export * from "./CategoryStoreForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports